/**
 * TTL per entity type. Used by StaleWhileRevalidate and Storage cleanup.
 */

export const CACHE_TTL_MS: Record<string, number> = {
  company_config: 24 * 60 * 60 * 1000, // 24h
  customer: 4 * 60 * 60 * 1000, // 4h
  agent: 4 * 60 * 60 * 1000,
  article: 4 * 60 * 60 * 1000,
  item_category: 4 * 60 * 60 * 1000,
  payment_method: 4 * 60 * 60 * 1000,
  agent_customer_item: 4 * 60 * 60 * 1000,
  visit: 4 * 60 * 60 * 1000,
  order: 4 * 60 * 60 * 1000,
  customer_deadlines: 15 * 60 * 1000, // 15min
};

const DEFAULT_TTL_MS = 4 * 60 * 60 * 1000; // 4h

export function getTtlMs(entityType: string): number {
  return CACHE_TTL_MS[entityType] ?? DEFAULT_TTL_MS;
}

export function isStale(entityType: string, lastSyncAt: string | null): boolean {
  if (!lastSyncAt) return true;
  const ttl = getTtlMs(entityType);
  const age = Date.now() - new Date(lastSyncAt).getTime();
  return age > ttl;
}

export function getHumanReadableAge(lastSyncAt: string): string {
  const ageMs = Date.now() - new Date(lastSyncAt).getTime();
  const minutes = Math.floor(ageMs / 60000);
  const hours = Math.floor(ageMs / 3600000);
  const days = Math.floor(ageMs / 86400000);

  if (days > 0) return `${days}g fa`;
  if (hours > 0) return `${hours}h fa`;
  if (minutes > 0) return `${minutes}min fa`;
  return 'ora';
}

/** Cleanup priority: lower = evicted first. */
export const CLEANUP_PRIORITY: Record<string, number> = {
  customer_deadlines: 1,
  visit: 2,
  order: 3,
  agent_customer_item: 4,
  article: 5,
  item_category: 6,
  payment_method: 7,
  customer: 8,
  agent: 9,
  company_config: 10,
};

export function getCleanupPriority(entityType: string): number {
  return CLEANUP_PRIORITY[entityType] ?? 5;
}
